import {VideoObjectConfig} from 'shared/interfaces/object_config';
import {SphereItem} from './sphere_item';
import VideoObject3D from 'shared/object3d/VideoObject3D';

export default class VideoItem extends SphereItem {
  object3D: VideoObject3D;

  private wasPausedManually: boolean = false;
  private ended: boolean = false;

  allowToLoad(allow: boolean) {
    if (allow) this.object3D.preloadVideo();
    else this.object3D.unloadVideo();
  }

  private isAllowedToPlay: boolean = true;
  allowToPlay(allow: boolean) {
    this.isAllowedToPlay = allow;
    if (allow && !this.object3D.isPlaying() && this.canAutoplay()) this.object3D.setPlaying(true);
    if (!allow && this.object3D.isPlaying()) this.object3D.setPlaying(false);
  }

  private canAutoplay() {
    return this.config().autoplay && this.isAllowedToPlay && !this.wasPausedManually && !this.ended;
  }

  config(): VideoObjectConfig {
    return this.itemData.data as VideoObjectConfig;
  }
}
